
<div *ngIf="loading"  class="dds__modal dds__loading-modal dds__d-block" tabindex="-1" role="dialog"   >
  <div class="dds__modal-dialog" role="document">
    <div class="dds__modal-content">
      <div class="dds__modal-body dds__text-center">
        <div class="dds__mb-3" id="modalId">
          <div class="dds__progress-bar">
            <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
              role="progressbar" data-showtext="true"></div>
          </div>
        </div>
        <p>Processing... Please wait.</p>
      </div>
    </div>
  </div>
</div>



<div  class="dds__container">
  <div class="dds__h2" style="text-align: center;margin:30px;">My Dashboard</div>
  <br>
  <div class="dds__row">
    <div *ngFor="let key of objectKeys(widgets)" class="dds__col-sm-12 dds__col-md-6 dds__col-lg-3 dds__mb-4">
      <a style="text-decoration: none;" [attr.title]="key + ' ' + widgets[key]" [routerLink]="widgets[key]==0?'/portal':('/grid/'+key)" >
        <section tabindex="-1" class="dds__dell-container dds__dell-container" [attr.aria-label]="key">
          <div class="dds__dell-container-body dds__pr-1 dds__pt-1 dds__p-0">
            <div class="dds__d-flex dds__justify-content-between">
              <p class="dds__dell-container-text dds__text-primary dds__pl-2 dds__h5">{{key}}</p>
              <svg  class="dds__svg-icons dds__text-granite" aria-hidden="true" style="height: 35px; width: 35px;pointer-events: none">
                <use [attr.xlink:href]="widgetIconMap.get(key)"  />
              </svg>
            </div>
          </div>
          <div class="dds__dell-container-body dds__px-2 dds__py-3">
            <div class="dds__d-flex dds__justify-content-start">
              <p style="font-size: 32px; height: 26px"
                class="dds__bold-16 dds__text-primary dds__float-left dds__text-truncate dds__w-100 dds__pt-1">{{widgets[key]}}</p>
            </div>
          </div>
        </section>
      </a>
    </div>
  </div>
</div>

